import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';

export default function helixReducer(state = initialState.helixProjects, action) {
	switch (action.type) {
		case actions.GET_HELIX_PROJECT:
			return action.response || state;
		default:
			return state;
	}
}
